import React from "react";
import { useParams } from "react-router-dom";

const FlightDetails = () => {
  const { citySlug } = useParams();

  // Convert slug to formatted text (new-york → New York)
  const formattedCity = citySlug
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");

  return (
    <div className="bg-gradient-to-br from-[#020617] via-[#0B1E34] to-[#132F4C] 
                    text-[#E6F1F7] rounded-xl max-w-5xl mx-auto px-6 py-10 shadow-xl">

      <h1 className="text-3xl font-bold mb-6 text-orange-400">
        Book a Cheap Flight Ticket to {formattedCity} with BookTrip4Me
      </h1>

      <p className="mb-4 text-gray-200">
        {formattedCity}, known for its natural charm, cultural hotspots, and modern
        entertainment, is the perfect destination for all types of travelers.
        From beaches and nightlife to historical attractions and delicious food,
        <b> {formattedCity} </b> has something for everyone.
        If you’re planning your trip, <b>BookTrip4Me</b> can help you book
        affordable flights instantly.
      </p>

      <p className="mb-6 text-gray-200">
        BookTrip4Me offers exclusive deals and discounts for flights to{" "}
        {formattedCity}. Whether you are flying domestically or internationally,
        you can reserve your ticket at the lowest possible fare.
      </p>

      <h2 className="text-2xl font-semibold text-orange-300 mb-3">
        {formattedCity} Airport Information
      </h2>
      <ul className="mb-6 text-gray-200">
        <li>
          <b>Airport Name:</b> {formattedCity} International Airport
        </li>
        <li>
          <b>Code:</b> TBD
        </li>
      </ul>

      <h2 className="text-2xl font-semibold text-orange-300 mb-3">
        Airlines Flying To/From {formattedCity}
      </h2>
      <ul className="list-disc pl-6 mb-6 text-gray-200">
        <li>United Airlines</li>
        <li>Emirates</li>
        <li>Delta Air Lines</li>
        <li>Akasa Air</li>
        <li>Saudi Arabia</li>
        <li>Etihad Airways</li>
        <li>Ethiopian Airlines</li>
      </ul>

      <h2 className="text-2xl font-semibold text-orange-300 mb-3">
        How to Book a Flight Ticket to {formattedCity} on BookTrip4Me
      </h2>
      <ol className="list-decimal pl-6 mb-6 text-gray-200 space-y-2">
        <li>Visit our official website: <b>www.BookTrip4Me.com</b>.</li>
        <li>Select your flight type (one-way, round-trip, or multi-city).</li>
        <li>Enter your departure and arrival cities.</li>
        <li>Choose your travel dates.</li>
        <li>Select number of passengers.</li>
        <li>Click the Search button to view available flights.</li>
        <li>Pick your preferred flight and add traveler details.</li>
        <li>Proceed to payment and confirm your booking.</li>
        <li>Your e-ticket will be emailed instantly.</li>
      </ol>

      <h2 className="text-2xl font-semibold text-orange-300 mb-3">
        Tips to Book Cheap Flights to {formattedCity}
      </h2>
      <ul className="list-disc pl-6 text-gray-200 space-y-2">
        <li><b>Book Early:</b> Ticket prices increase closer to the departure date.</li>
        <li><b>Look for Deals:</b> BookTrip4Me offers frequent discounts.</li>
        <li><b>Enable Price Alerts:</b> Get notified when fares drop.</li>
        <li><b>Flexible Travel Dates:</b> Flying mid-week often saves money.</li>
      </ul>
    </div>
  );
};

export default FlightDetails;
